import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PagesComponent } from "./pages/pages.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { RegistrationComponent } from "./registration/registration.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { HomeComponent } from "./pages/home/home.component";
import { WhoComponent } from "./pages/who/who.component";
import { ServicesComponent } from "./pages/services/services.component";
import { NewsComponent } from "./pages/news/news.component";
import { SayComponent } from "./pages/say/say.component";
import { JoinComponent } from "./pages/join/join.component";
import { ContactsComponent } from "./pages/contacts/contacts.component";
import { FindComponent } from "./pages/find/find.component";
import { InnovazioneRicercaComponent } from './pages/cerca-bando/innovazione-ricerca/innovazione-ricerca.component';
import { DigitaleIntelligenzaArtificialeComponent } from "./pages/cerca-bando/digitale-intelligenza-artificiale/digitale-intelligenza-artificiale.component";
import { BandoComponent } from "./pages/bando/bando.component";
import { LoginComponent } from "./auth/login/login.component";
import { AuthComponent } from "./auth/auth.component";
import { ContainerComponent } from "./manager/container.component";
import { bookings, catalog, catalogAdmin, categories, companies, dates, documents, noticeAdmissibilityRequest, noticeDetailsAdmin, notices, noticesAdmin, partner, partners, partnersToApprove, payments, permissions, plans, projects, projectsAdmin, requests, roles, timetables, user } from "./models/universal-json";
import { CompleteComponent } from "./complete/complete.component";
import { mockData } from "../mockData";
import { ProjectComponent } from "./manager/project/project.component";
import { BandoDetailsComponent } from "./manager/bandoDetails/bando-details.component";
import { ProfileComponent } from "./manager/profile/profile.component";
import { UniversalCrudComponent } from "./components/universal-crud/universal-crud.component";
import { PricingComponent } from "./pages/pricing/pricing.component";
import { ImportNoticeCSVComponent } from "./tables-custom-actions/import-notice-csv.component";
import { UniversalDetailsComponent } from "./components/universal-details/universal-details.component";
import { UniversalCreateComponent } from "./components/universal-create/universal-create.component";
import { CatalogCompaniesComponent } from "./manager/catalogCompanies/catalogCompanies.component";
import { GreenTransizioneEcologicaComponent } from "./pages/cerca-bando/green-transizione-ecologica/green-transizione-ecologica.component";
import { StartupNuoveImpreseComponent } from "./pages/cerca-bando/startup-nuove-imprese/startup-nuove-imprese.component";
import { InvestimentiBeniStrumentaliComponent } from "./pages/cerca-bando/investimenti-beni-strumentali/investimenti-beni-strumentali.component";
import { MezzogiornoAreeAgevolateComponent } from "./pages/cerca-bando/mezzogiorno-aree-agevolate/mezzogiorno-aree-agevolate.component";
import { ExportInternazionalizzazioneComponent } from "./pages/cerca-bando/export-internazionalizzazione/export-internazionalizzazione.component";
import { ImpreseStartupComponent } from "./pages/piani/imprese-startup/imprese-startup.component";
import { EntiPubbliciComponent } from "./pages/piani/enti-pubblici/enti-pubblici.component";
import { PartnerComponent } from "./pages/piani/partner/partner.component";
import { PreferenceComponent } from "./manager/preference/preference.component";




let routes: Routes = [
  {
    path: "",
    component: PagesComponent,

    children: [
      { path: '', component: HomeComponent ,
        data: {
          titleSeo: "Consulenza e Ricerca Bandi UE | Innovation Plaza",
          metadescription: "Supportiamo imprese e PA nello sviluppo di progetti innovativi e accesso a bandi europei,nazionali e regionali. Scropri i nostri servizi. ",
        }
      },
      { path: 'chi-siamo', component: WhoComponent ,
        data: {
          titleSeo: "Chi Siamo | Innovation Plaza Consulenza Innovazione",
          metadescription: "Innovation Plaza è una società di consulenza che supporta imprese e istituzioni nello sviluppo di progetti innovativi e accsso ai fondi pubblici ",
        }
      },
      { path: 'servizi', component: ServicesComponent },
      { path: 'news', component: NewsComponent },
      { path: 'dicono-di-noi', component: SayComponent },
      { path: 'unisciti-al-team', component: JoinComponent },     
      { path: 'contatti', component: ContactsComponent ,
        data: {
          titleSeo: "Contatti Innovation Plaza  | Richiedi Consulenza",
          metadescription: "Contatta Innovation Plaza per supporto su bandi, innovazione e finanza agevolata. Il nostro team ti risponderà rapidamente.",
        }

       },
      {
        path: 'cerca-bando/innovazione-ricerca', component: InnovazioneRicercaComponent,
        data: {
          titleSeo: "Bandi Innovazione e Ricerca – Finanziamenti PMI | Innovation Plaza",
          metadescription: "Scopri bandi e incentivi per innovazione e ricerca: contributi PNRR, Horizon Europe e legge Patent Box per PMI",
        }
      },
      {
        path: 'cerca-bando/digitale-intelligenza-artificiale', component: DigitaleIntelligenzaArtificialeComponent,
        data: {
          titleSeo: "Bandi Digitalizzazione & Intelligenza Artificiale – PMI | Innovation Plaza",
          metadescription: "Finanziamenti digitalizzazione PMI: scopri bandi per tecnologie 4.0, AI, cybersecurity e cloud. Incentivi PNRR con crediti d’imposta Transizione 4.0",
        }
      },
      {
        path: 'cerca-bando/green-transizione-ecologica', component: GreenTransizioneEcologicaComponent,
        data: {
          titleSeo: "Bandi Green & Transizione Ecologica – PMI | Innovation Plaza",
          metadescription: "Agevolazioni green per PMI: bandi su energie rinnovabili, efficienza energetica e circolarità. Incentivi PNRR Transizione 5.0 e programma LIFE",
        }
      },
      {
        path: 'cerca-bando/startup-nuove-imprese', component: StartupNuoveImpreseComponent,
        data: {
          titleSeo: "Bandi Startup & Nuove Imprese – PMI | Innovation Plaza",
          metadescription: " Incentivi per startup innovative e nuove imprese: finanziamenti a tasso zero (ON), bandi Smart&Start, fondi PNRR per imprese giovanili/femminili",
        }
      },
      {
        path: 'cerca-bando/investimenti-beni-strumentali', component: InvestimentiBeniStrumentaliComponent,
        data: {
          titleSeo: "Bandi Investimenti & Beni Strumentali – PMI | Innovation Plaza",
          metadescription: "Finanziamenti acquisto macchinari e attrezzature: Nuova Sabatini e crediti d’imposta Industria 4.0. Contributi a fondo perduto e prestiti agevolati per PMI",
        }
      },
      {
        path: 'cerca-bando/mezzogiorno-aree-agevolate', component: MezzogiornoAreeAgevolateComponent,
        data: {
          titleSeo: "Bandi Mezzogiorno & Aree Agevolate – PMI | Innovation Plaza",
          metadescription: "Agevolazioni Sud: contributi e crediti d’imposta potenziati per imprese al Mezzogiorno. Incentivi ZES, sostegno PNRR e Politiche di Coesione",
        }
      },
      {
        path: 'cerca-bando/export-internazionalizzazione', component: ExportInternazionalizzazioneComponent,
        data: {
          titleSeo: "Bandi Export & Internacionalizzazione – PMI | Innovation Plaza",
          metadescription: "Sostieni la tua internazionalizzazione: fondo SIMEST 394 per export PMI, Temporary Export Manager e contributi per fiere estere",
        }
      },
      { path: 'cerca-bando', component: FindComponent, 
        data: { 
          titleSeo: "Cerca Bandi e Finanziamenti | Innovation Plaza",
          metadescription: "Trova bandi europei,nazionali e regionali per la tua impresa.Accedi alle migliori opportunità di finanziamento con Innovation Plaza.",
       } 
    },
      { path: 'bando/:id', component: BandoComponent },
      { path: 'piani', redirectTo: 'piani/imprese-startup', pathMatch: 'full' ,
        data: {
          titleSeo: "Piani e Servizi di Consulenza Innovazione | Innovation Plaza",
          metadescription: "Scopri i nostri piani di consulenza per innovazione,bandi e finanziamenti.Soluzioni su misura per impree,startup e pubblica amministrazione.",
        }
      },
      { path: 'piani/imprese-startup', component: ImpreseStartupComponent },
      //{ path: 'piani', component: ImpreseStartupComponent },
      //{ path: 'piani/imprese-startup', redirectTo: 'piani', pathMatch: 'full' },
      { path: 'piani/enti-pubblici', component: EntiPubbliciComponent ,
        data: {
          titleSeo: "Consulenza per Enti Pubblici e Bandi | Innovation Plaza",
          metadescription: "Supportiamo enti pubblici nella gestione di bandi, finanziamenti e progetti innovativi con consulenza strategica e project management.",
        }
      },
      { path: 'piani/partner', component: PartnerComponent ,
        data: {
          titleSeo: "Partnership Strategiche e Innovazione | Innovation Plaza",
          metadescription: "Scopri i programmi partnership di Innovation Plaza per aziende, consulenti e stakeholder dell’innovazione e della finanza agevolata.",
        }
       },
        { path: 'piani/Partner', component: PartnerComponent ,
        data: {
          titleSeo: "Partnership Strategiche e Innovazione | Innovation Plaza",
          metadescription: "Scopri i programmi partnership di Innovation Plaza per aziende, consulenti e stakeholder dell’innovazione e della finanza agevolata.",
        }
       },

    ],
  },
  {
    path: "",
    component: ContainerComponent,
    children: [
      { path: 'bandi', component: UniversalCrudComponent, data: { ...notices, mockData: mockData } },
      { path: 'bandi-admin', component: UniversalCrudComponent, data: { ...noticesAdmin, mockData: mockData } },
      { path: 'richieste', component: UniversalCrudComponent, data: { ...requests, mockData: mockData } },
      { path: 'richieste-ammissibilita', component: UniversalCrudComponent, data: { ...noticeAdmissibilityRequest, mockData: mockData } },
      { path: 'partners', component: UniversalCrudComponent, data: { ...partners, mockData: mockData } },
      { path: 'partners-to-approve', component: UniversalCrudComponent, data: { ...partnersToApprove, mockData: mockData } },
      { path: 'partner/:id', component: UniversalDetailsComponent, data: { ...partner, mockData: mockData } },
      { path: 'crea-bando', component: UniversalCreateComponent, data: { ...noticeDetailsAdmin, mockData: mockData } },
      { path: 'catalogo', component: CatalogCompaniesComponent },
      { path: 'catalogo-partner', component: UniversalCrudComponent, data: { ...catalogAdmin, mockData: mockData } },
      { path: 'appuntamenti', component: UniversalCrudComponent, data: { ...bookings, mockData: mockData } },
      {
        path: 'bandi-admin', component: UniversalCrudComponent, data: {
          ...notices, mockData: mockData, customActions: [{
            component: ImportNoticeCSVComponent,
            label: "Importa bando",
            translateLabel: false
          }]
        }
      },
      { path: 'dettaglio-bando/:id', component: BandoDetailsComponent },
      { path: 'dettaglio-bando-admin/:id', component: UniversalDetailsComponent, data: { ...noticeDetailsAdmin, mockData: mockData } },
      { path: 'pagamenti', component: UniversalCrudComponent, data: { ...payments, mockData: mockData } },
      { path: 'ruoli', component: UniversalCrudComponent, data: { ...roles, mockData: mockData } },
      { path: 'tech/:id/products', component: UniversalCrudComponent, data: { ...companies, mockData: mockData } },
      { path: 'permessi', component: UniversalCrudComponent, data: { ...permissions, mockData: mockData } },
      // { path: 'appuntamenti', component: UniversalCrudComponent, data: { ...schedules, mockData: mockData } },
      { path: 'categorie', component: UniversalCrudComponent, data: { ...categories, mockData: mockData } },
      { path: 'documenti', component: UniversalCrudComponent, data: { ...documents, mockData: mockData } },
      { path: 'utenti', component: UniversalCrudComponent, data: { ...user, mockData: mockData } },
      { path: 'piani-admin', component: UniversalCrudComponent, data: { ...plans, mockData: mockData } },
      { path: 'giorni', component: UniversalCrudComponent, data: { ...timetables, mockData: mockData } },
      { path: 'date', component: UniversalCrudComponent, data: { ...dates, mockData: mockData } },
      { path: 'progetti', component: UniversalCrudComponent, data: { ...projects, mockData: mockData } },
      { path: 'progetti-admin', component: UniversalCrudComponent, data: { ...projectsAdmin, mockData: mockData } },
      { path: 'progetto/:id', component: ProjectComponent },
      { path: 'profilo', component: ProfileComponent, data: { ...projects, mockData: mockData } },
      { path: 'preferenze', component: PreferenceComponent},


    ],
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      { path: "login", component: LoginComponent },
      { path: "registrazione", component: RegistrationComponent },
      { path: "completa-profilo", component: CompleteComponent },
      { path: "seleziona-piano", component: PricingComponent },
      { path: "recupero-password", component: RecoveryPasswordComponent },
      { path: "cambia-password", component: ChangePasswordComponent },
    ]
  },

];


@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
